/* eslint-disable import/prefer-default-export */
export const QUESTION_ANIMATION_DURATION_MS = 500;